import { createMultiStyleConfigHelpers as f, defineStyle as l } from "@chakra-ui/react";
import { isTouchScreenDevice as m } from "../../theme-helper.js";
import { ThemeColorVariable as n } from "../../theme-types.js";
import { ThemeColorToken as o, ThemeSpaceToken as r, ThemeRadiusToken as t, ThemeBorderToken as d, ThemeFontToken as s, ThemeFontSizeToken as i } from "../theme-tokens.js";
import { inputAnatomy as b } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { definePartsStyle: a, defineMultiStyleConfig: p } = f(b.keys), c = {
  fontFamily: s.Body,
  color: o.OnSurface,
  border: d.XSmall,
  borderColor: o.OnSurfaceBorder,
  background: o.Surface,
  borderRadius: t.Small,
  paddingInlineStart: r.Small,
  paddingInlineEnd: r.Small,
  width: "100%",
  _disabled: {
    cursor: "not-allowed",
    background: o.SurfaceDisabled,
    color: o.OnSurfaceSubdued,
    border: 0,
    opacity: 1
  },
  _readOnly: {
    color: o.OnSurface,
    background: o.SurfaceDisabled,
    userSelect: "text",
    opacity: 1,
    border: 0
  },
  _placeholder: {
    color: o.OnSurfaceSubdued,
    opacity: 1
  },
  _invalid: {
    borderColor: o.Error,
    boxShadow: `0 0 0 4px ${n.ErrorContainer}`
  },
  _focus: {
    borderColor: o.Info,
    boxShadow: `0 0 0 4px ${n.InfoContainer}`
  },
  _hover: {
    borderColor: m() ? o.OnSurfaceBorder : o.OnSurface,
    _disabled: void 0,
    _readOnly: void 0
  }
}, u = {
  color: o.OnSurface,
  background: o.SurfaceDisabled,
  borderColor: o.OnSurfaceBorder,
  borderRadius: t.Small,
  px: r.Medium,
  _disabled: {
    opacity: 1,
    cursor: "not-allowed",
    background: o.SurfaceDisabled
  },
  _readOnly: {
    opacity: 1,
    background: o.SurfaceDisabled
  }
}, S = {
  color: o.OnSurface,
  _disabled: {
    opacity: 1,
    color: o.OnSurfaceSubdued
  }
}, e = {
  lg: l({
    fontSize: i.Medium,
    px: r.Medium
  }),
  md: l({
    fontSize: i.Medium,
    px: r.Small
  }),
  sm: l({
    fontSize: i.Small,
    px: r.Small
  })
}, g = {
  lg: a({
    field: e.lg,
    addon: e.lg,
    element: e.lg
  }),
  md: a({
    field: e.md,
    addon: e.md,
    element: e.md
  }),
  sm: a({
    field: e.sm,
    addon: e.sm,
    element: e.sm
  })
}, h = a({
  field: {
    ...c,
    border: d.XSmall,
    borderColor: "transparent",
    background: "none",
    color: o.OnSurface,
    _focus: {
      border: d.XSmall,
      borderColor: o.Info,
      boxShadow: `0 0 0 4px ${n.InfoContainer}`,
      backgroundColor: o.Surface
    },
    "@media(hover: hover)": {
      "&:hover": {
        borderColor: o.Info
      },
      "&:hover:not(:focus)": {
        backgroundColor: o.SurfaceDisabled,
        borderColor: "transparent"
      }
    },
    _invalid: {
      border: d.XSmall,
      borderColor: o.Error,
      boxShadow: `0 0 0 4px ${n.ErrorContainer}`
    }
  },
  addon: u,
  element: S
}), C = {
  outline: {
    field: c,
    addon: u,
    element: S
  },
  ghost: h
}, _ = p({
  sizes: g,
  variants: C,
  defaultProps: {
    variant: "outline"
  }
});
export {
  _ as inputConfig
};
